const STORAGE_PREFIX = 'agents.lastThread'
const WIDTH_PREFIX = 'agents.panelWidth'
const TTL_MS = 30 * 24 * 60 * 60 * 1000 // 30 days

const storageKey = (agentId, viewScope) => `${STORAGE_PREFIX}.${agentId}.${viewScope}`
const widthKey = (agentId, viewScope) => `${WIDTH_PREFIX}.${agentId}.${viewScope}`

export function readStoredThread (agentId, viewScope) {
  if (!agentId || viewScope === undefined || viewScope === null) return null
  try {
    const raw = window.localStorage.getItem(storageKey(agentId, viewScope))
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (!parsed?.threadId || !parsed?.savedAt) return null
    const savedMs = Date.parse(parsed.savedAt)
    if (Number.isNaN(savedMs) || Date.now() - savedMs > TTL_MS) {
      window.localStorage.removeItem(storageKey(agentId, viewScope))
      return null
    }
    return parsed.threadId
  } catch {
    return null
  }
}

export function writeStoredThread (agentId, viewScope, threadId) {
  if (!agentId || viewScope === undefined || viewScope === null || !threadId) return
  try {
    window.localStorage.setItem(
      storageKey(agentId, viewScope),
      JSON.stringify({ threadId, savedAt: new Date().toISOString() })
    )
  } catch {
    // ignore quota / privacy errors
  }
}

export function clearStoredThread (agentId, viewScope) {
  if (!agentId || viewScope === undefined || viewScope === null) return
  try {
    window.localStorage.removeItem(storageKey(agentId, viewScope))
  } catch {
    // ignore
  }
}

export function readStoredPanelWidth (agentId, viewScope) {
  if (!agentId || viewScope === undefined || viewScope === null) return null
  try {
    const raw = window.localStorage.getItem(widthKey(agentId, viewScope))
    if (!raw) return null
    const parsed = JSON.parse(raw)
    const width = Number(parsed?.width)
    if (!Number.isFinite(width) || width <= 0) return null
    return width
  } catch {
    return null
  }
}

export function writeStoredPanelWidth (agentId, viewScope, width) {
  if (!agentId || viewScope === undefined || viewScope === null) return
  if (!Number.isFinite(width) || width <= 0) return
  try {
    window.localStorage.setItem(
      widthKey(agentId, viewScope),
      JSON.stringify({ width, savedAt: new Date().toISOString() })
    )
  } catch {
    // ignore
  }
}
